'use client'

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  // eslint-disable-next-line no-console
  console.log({ error })

  return (
    <html>
      <head></head>
      <body>
        <div className="s-microsite">
          <h2>Something went wrong in RootLayout!</h2>
          <button onClick={() => reset()}>Try again</button>
        </div>
      </body>
    </html>
  )
}
